import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import ViewSpiner from 'components/ViewSpinner';
import RestService from 'utils/RestService';
import ViewPageToolbar from 'components/ViewPageToolbar';
import { browserHistory } from 'react-router';
import { isTerminal } from 'utils/UiHelper';

export default class InfoPage extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
        };
    }

    onBackBtnHandler() {
        browserHistory.goBack(); //push('/hjaelp');
    }

    componentWillMount() {
        RestService.GetText(this.props.params.id, (data) => {
            this.setState({ data: data });
        });
    }

    render() {
        const spiner = <ViewSpiner />;
        const title = this.state.data ? (
            <ViewPageToolbar
                title={this.state.data.title}
                onBackBtn={this.onBackBtnHandler.bind(this)}
            />
        ) : null;
        const content = this.state.data ? (
            <div className="p10">{renderHTML(this.state.data.content)}</div>
        ) : (
            spiner
        );

        const styleObject =
            this.props.params.id === 'sadan_spiller_du'
                ? {
                      color: '#fff',
                      fontSize: '40px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                  }
                : {};

        return (
            <div
                className={isTerminal() ? 'info-page' : 'info-page pb80'}
                style={styleObject}
            >
                {title}
                {content}
            </div>
        );
    }
}
